export default "__VITE_ASSET__DPgnE_Hx__"